export const environment = {
  envName: 'development',
  apiUrl: 'https://pass-api-dev.nside.io',
  // nSide Identity v2: sign-in page, cookie session and the API-token exchange (docs/plans/sso-sign-in.md).
  identityUrl: 'https://identity-v2-dev.nside.io',
  // Password login, registration and reset stay until the API turns LEGACY_AUTH_ENABLED off.
  legacyAuth: true,
};
